/* eslint-disable no-undef */
import React from 'react';
import PropTypes from 'prop-types';
import isMobile from 'ismobilejs';
import { withStyles } from '@material-ui/core/styles';
import {
  Table,
  TableBody,
  TableCell,
  Button,
  IconButton,
  TablePagination,
  TableRow,
  Paper,
  Avatar,
  Tooltip,
} from '@material-ui/core';
import { orange, red, blue, green, grey } from '@material-ui/core/colors';
import DeleteIcon from '@material-ui/icons/Delete';
import CallSplitIcon from '@material-ui/icons/CallSplit';
import {
  defaultColumnData,
  valueFormat,
  onceitProductUrl,
  onceitSaleUrl,
} from '../common/constants';
import EnhancedTableHead from './EnhancedTableHead';
import EnhancedTableToolbar from './EnhancedTableToolbar';
import OrderDetails from './orderDetails/index';
import AlertDialog from './AlertDialog';
import TrackingNumber from './TrackingNumber';
import TrackingCourier from './TrackingCourier';
import DollorsInput from './DollorsInput';
import OrderCellMobile from './OrderCellMobile';
import SplitShipment from './SplitShipment';

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: 50,
    backgroundColor: '#fff',
  },
  table: {
    width: '100%',
    minWidth: 600,
  },
  tableInSide: {
    width: '100%',
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 150,
  },
  tableCell: {
    padding: '4px',
  },
  tableCellInside: {
    border: 0,
  },
  button: {
    margin: theme.spacing.unit,
    // frontColor: theme.palette.background.default,
    color: '#4e91fd',
  },
  deleteButton: {
    margin: theme.spacing.unit,
    // frontColor: theme.palette.background.default,
    color: '#fd1013',
  },
  avatarRed: {
    marginLeft: 10,
    color: '#fff',
    backgroundColor: red[500],
  },
  avatarOrange: {
    marginLeft: 10,
    color: '#fff',
    backgroundColor: orange[500],
  },
  avatarBlue: {
    marginLeft: 10,
    color: '#fff',
    backgroundColor: blue[500],
  },
  avatarGreen: {
    marginLeft: 10,
    color: '#fff',
    backgroundColor: green[500],
  },
  avatarGrey: {
    marginLeft: 10,
    color: '#fff',
    backgroundColor: grey[500],
  },
});

class EnhancedTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      result: props.result,
      currentOrder: null,
      perPageOptions: [20, 50, 100],
      errors: props.errors,
      pageInfo: props.pageInfo,
    };
    this.handleCloseDetails = this.handleCloseDetails.bind(this);
    this.handleCloseSplitShipment = this.handleCloseSplitShipment.bind(this);
    this.handleOnSplitShipment = this.handleOnSplitShipment.bind(this);
    this.handleOnSubmitSplit = this.handleOnSubmitSplit.bind(this);
    this.handleOnClick = this.handleOnClick.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      result: nextProps.result,
      errors: nextProps.errors,
      pageInfo: nextProps.pageInfo,
    });
  }

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';

    if (this.state.pageInfo.orderBy === property && this.state.pageInfo.order === 'desc') {
      order = 'asc';
    }
    this.props.handleRequestSort(order, orderBy);
  };

  handleChangePage = (event, page) => {
    this.props.handleChangePage(page);
  };

  handleChangePageSize = event => {
    this.props.handleChangePageSize(event.target.value);
  };

  handleCloseDetails = () => {
    this.setState({ currentOrder: null });
  };

  handleCloseSplitShipment = () => {
    this.setState({ currentSplitOrder: null });
  };

  handleOnClick = order => {
    this.setState({ currentOrder: order });
  };

  handleOnSplitShipment = order => {
    this.setState({ currentSplitOrder: order });
  };

  handleOnSubmitSplit = (order, products) => {
    this.props.handleOnSubmitSplit(order, products);
    this.setState({ currentSplitOrder: null });
  };

  render() {
    const {
      classes,
      handleFilter,
      doFilter,
      doRest,
      doExport,
      doImport,
      handleCloseAlert,
      filters,
      setTrackingNumber,
      setShipmentCost,
      setCourier,
      removeTracking,
      withOutToolBar,
      withOutPagination,
      readOnly,
      isTableOnly,
      handleOnSubmitSplit,
      carriers,
    } = this.props;
    const {
      result,
      errors,
      pageInfo: { order, orderBy, pageSize, page },
      currentOrder,
      currentSplitOrder,
      perPageOptions,
    } = this.state;
    const columnData = this.props.columnData ? this.props.columnData : defaultColumnData;

    const data = result ? result.data : [];

    // Once currentOrder updated it need the updated order
    let updatedCurrentOrder = null;
    if (data && currentOrder) {
      updatedCurrentOrder = data.filter(order => order.shipmentRef === currentOrder.shipmentRef);
      if (updatedCurrentOrder) {
        updatedCurrentOrder = updatedCurrentOrder[0];
      }
    }

    const metadata = result ? result.metadata : [];
    const parameters =
      errors && errors.length > 0
        ? {
            title: 'Errors',
            message: errors.map(error => error.message || error.error),
            okButtonName: 'OK',
            handleClose: handleCloseAlert,
          }
        : {};
    return (
      <div>
        <div className={classes.root} style={{ marginTop: withOutToolBar ? '0px' : '50px' }}>
          {!withOutToolBar && (
            <EnhancedTableToolbar
              handleFilter={handleFilter}
              doFilter={doFilter}
              doRest={doRest}
              filters={filters}
              doExport={doExport}
              doImport={doImport}
            />
          )}
          <div className={classes.tableWrapper}>
            {isMobile.phone &&
              data.map(order => (
                <OrderCellMobile
                  setTrackingNumber={setTrackingNumber}
                  setCourier={setCourier}
                  handleOnClick={this.handleOnClick}
                  order={order}
                  noButtons={withOutToolBar}
                  columnData={columnData}
                  removeTracking={removeTracking}
                  splitShipment={this.handleOnSplitShipment}
                  handleOpenDelete={this.props.handleOpenDelete}
                  setShipmentCost={setShipmentCost}
                  carriers={carriers}
                />
              ))}
            {!isMobile.phone && (
              <Table className={classes.table} aria-labelledby="ordersTable" id="ordersTable">
                <EnhancedTableHead
                  order={order}
                  orderBy={orderBy}
                  onRequestSort={this.handleRequestSort}
                  rowCount={data.length}
                  columnData={columnData}
                />
                <TableBody name="mainBody">
                  {data.map(order => (
                    <TableRow
                      hover
                      // onClick={event => this.handleClick(event, order.id)}
                      tabIndex={-1}
                      key={order.shipmentRef}
                    >
                      {columnData.map(item => (
                        <TableCell
                          key={`${order.shipmentRef}${item.id}`}
                          className={classes.tableCell}
                          numeric={!!item.numeric}
                          paddingNone
                          style={{
                            textAlign:
                              !!item.date || !!item.datetime || !!item.enum ? 'center' : '',
                          }}
                        >
                          {order[item.id] && typeof order[item.id] === 'object' ? (
                            order[item.id].map((arr, index) => (
                              <table
                                className={classes.tableInSide}
                                key={`${order.id}${item.id}${index}`}
                              >
                                <TableRow key={`${order.id}${item.id}${index}`}>
                                  <TableCell
                                    className={classes.tableCellInside}
                                    numeric={item.numeric}
                                    paddingNone
                                    style={{
                                      padding: '5px',
                                      fontWeight:
                                        item.id === 'quantity'
                                          ? arr * 100 > 900
                                            ? 900
                                            : arr * 100
                                          : 100,
                                    }}
                                  >
                                    {item.id === 'productShowName' ||
                                    item.id === 'productShowNameWithoutBarCode' ? (
                                      <a
                                        target="_blank"
                                        href={`${onceitProductUrl}${order.productIds[index]}`}
                                        rel="noreferrer"
                                      >
                                        {arr}
                                      </a>
                                    ) : item.id === 'saleIds' ? (
                                      <a
                                        target="_blank"
                                        href={`${onceitSaleUrl}${order[item.id]}/onceit`}
                                        rel="noreferrer"
                                      >
                                        {arr}
                                      </a>
                                    ) : (
                                      valueFormat(item, arr)
                                    )}
                                  </TableCell>
                                </TableRow>
                              </table>
                            ))
                          ) : item.id === 'shippingStatusLabel' ? (
                            <Avatar
                              className={
                                order[item.id] === 'late'
                                  ? classes.avatarRed
                                  : order[item.id] === 'today'
                                  ? classes.avatarOrange
                                  : order[item.id] === 'coming'
                                  ? classes.avatarBlue
                                  : order[item.id] === 'sent' || order[item.id] === 'Sent'
                                  ? classes.avatarGreen
                                  : order[item.id] === 'cancelled'
                                  ? classes.avatarGrey
                                  : ''
                              }
                            >
                              {order[item.id] === 'late'
                                ? 'L'
                                : order[item.id] === 'today'
                                ? 'T'
                                : order[item.id] === 'coming'
                                ? 'N'
                                : order[item.id] === 'sent' || order[item.id] === 'Sent'
                                ? 'S'
                                : order[item.id] === 'cancelled'
                                ? 'C'
                                : ''}
                            </Avatar>
                          ) : item.id === 'trackingNumber' ? (
                            <TrackingNumber
                              setTrackingNumber={setTrackingNumber}
                              trackingNumber={valueFormat(item, order[item.id])}
                              order={order}
                              readOnly={readOnly}
                            />
                          ) : item.id === 'courier' ? (
                            <TrackingCourier
                              setCourier={setCourier}
                              trackingCourier={order[item.id]}
                              order={order}
                              readOnly={readOnly}
                              carriers={carriers}
                            />
                          ) : item.id === 'supplierInputCost' && !readOnly ? (
                            <DollorsInput
                              setShipmentCost={setShipmentCost}
                              cost={order[item.id]}
                              order={order}
                              readOnly={readOnly}
                            />
                          ) : item.isLink ? (
                            <Button
                              color="primary"
                              className={classes.button}
                              onClick={() => {
                                this.handleOnClick(order);
                              }}
                            >
                              {order[item.id]}
                            </Button>
                          ) : (
                            valueFormat(item, order[item.id])
                          )}
                        </TableCell>
                      ))}
                      {!withOutToolBar && (
                        <Tooltip title="Split shipment">
                          <IconButton
                            onClick={() => this.handleOnSplitShipment(order)}
                            className={classes.button}
                            disabled={
                              order.products.length < 2 || order.shippingStatusLabel === 'cancelled'
                            }
                            aria-label="Split"
                          >
                            <CallSplitIcon />
                          </IconButton>
                        </Tooltip>
                      )}
                      {!withOutToolBar && (
                        <Tooltip title="Remove tracking">
                          <IconButton
                            onClick={() =>
                              this.props.handleOpenDelete(order.orderid, order.shipmentRef)
                            }
                            className={classes.deleteButton}
                            aria-label="Delete"
                            disabled={
                              (!order.trackingNumber && !order.courier) ||
                              order.shippingStatusLabel === 'cancelled'
                            }
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Tooltip>
                      )}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            )}
          </div>
          {!withOutPagination && data && data.length > 0 && (
            <TablePagination
              component="div"
              count={metadata && metadata.totalCount ? metadata.totalCount : 0}
              rowsPerPage={pageSize}
              page={page}
              backIconButtonProps={{
                'aria-label': 'Previous Page',
              }}
              nextIconButtonProps={{
                'aria-label': 'Next Page',
              }}
              rowsPerPageOptions={perPageOptions}
              onChangePage={this.handleChangePage}
              onChangeRowsPerPage={this.handleChangePageSize}
            />
          )}
        </div>
        {errors && errors.length > 0 && <AlertDialog parameters={parameters} />}

        {updatedCurrentOrder && (
          <OrderDetails
            orderInfo={updatedCurrentOrder}
            handleClose={this.handleCloseDetails}
            setTrackingNumber={setTrackingNumber}
            setCourier={setCourier}
            setShipmentCost={setShipmentCost}
            readOnly={readOnly}
            carriers={carriers}
          />
        )}
        {currentSplitOrder && (
          <SplitShipment
            order={currentSplitOrder}
            handleClose={() => this.handleCloseSplitShipment()}
            handleSubmit={this.handleOnSubmitSplit}
          />
        )}
      </div>
    );
  }
}

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired,
  result: PropTypes.object.isRequired,
  doFilter: PropTypes.func,
  handleFilter: PropTypes.func,
  handleCloseAlert: PropTypes.func,
  handleOnSubmitSplit: PropTypes.func,
  setTrackingNumber: PropTypes.func,
  setCourier: PropTypes.func,
  doRest: PropTypes.func,
  doExport: PropTypes.func,
  doImport: PropTypes.func,
  errors: PropTypes.object,
  filters: PropTypes.object,
  pageInfo: PropTypes.object,
  handleChangePage: PropTypes.func,
  handleChangePageSize: PropTypes.func,
  handleRequestSort: PropTypes.func,
  withOutToolBar: PropTypes.boolean,
  readOnly: PropTypes.boolean,
  withOutPagination: PropTypes.boolean,
  columnData: PropTypes.object,
  carriers: PropTypes.array,
};

export default withStyles(styles)(EnhancedTable);



// WEBPACK FOOTER //
// ./src/components/orders/EnhancedTable.js